import Modal from "components/elements/Modal";
import Typography, { ITypo } from "components/elements/Typography";
import classes from "./classes.module.scss";
import { useCallback, useEffect } from "react";
import CorporationSheetResponseResource from "common/resources/CorporationSheet/CorporationSheetResponseResource";
import { container } from "tsyringe";
import ModuleConfig from "configs/ModuleConfig";
import SubscribersCorporationElement from "components/elements/subscriptionSummaryElements/SubscribersCorporationElement";
import { useLocation, useNavigate } from "react-router-dom";
import PencilSquareIcon from "@heroicons/react/24/outline/PencilSquareIcon";
import Button from "components/elements/Button";
import I18n from "components/materials/I18n";
import SubscriptionResponseResource from "common/resources/Subscription/SubscriptionResponseResource";

const corporationDetailsModule = container.resolve(ModuleConfig).get().modules.pages.Clients.props.pages.Corporations.props.pages.CorporationDetails;

type IProps = {
	isOpen: boolean;
	isFromSubscriptionTunnel?: boolean;
	corporation: CorporationSheetResponseResource;
	subscription?: SubscriptionResponseResource;
	onClose: () => void;
	onContinue: () => void;
	title: string;
	subtitle: string;
};

export default function EditCorporationModal(props: IProps) {
	const navigate = useNavigate();
	const location = useLocation();
	const { isOpen, onClose, onContinue, title, subtitle, corporation, isFromSubscriptionTunnel, subscription } = props;

	useEffect(() => {
		if (isOpen) {
			window.scrollTo(0, 0);
		}
	}, [isOpen]);

	const onContinueClick = useCallback(() => {
		onClose();
		onContinue();
	}, [onClose, onContinue]);

	const onModifyClick = useCallback(() => {
		const url = corporationDetailsModule.props.pages.EditCorporation.props.path.replace(":corporationSheetId", corporation.id);
		if (isFromSubscriptionTunnel) {
			if (!subscription) {
				console.error("Subscription is not available.");
				return;
			}
			const actualPath = location.pathname;
			const finalUrl = url.concat(`?redirectUrl=${actualPath}`);
			return navigate(finalUrl, { state: { from: "subscription-tunnel", subscriptionId: subscription.id } });
		}
		navigate(url);
	}, [corporation.id, location.pathname, navigate, subscription, isFromSubscriptionTunnel]);

	return (
		<Modal isOpen={isOpen} onClose={onClose} className={classes["root"]} fullwidth>
			<Typography typo={ITypo.DISPLAY_MEDIUM}>{title}</Typography>
			<Typography typo={ITypo.P_MEDIUM_BOLD}>{subtitle}</Typography>
			<div className={classes["root"]}>
				{corporation && <SubscribersCorporationElement corporationSheet={corporation} />}
				<div className={classes["button-container"]}>
					<Button className={classes["submit-button"]} icon={<PencilSquareIcon />} iconposition="right" onClick={onModifyClick}>
						{I18n.asset.pages.client.sub_pages.personal_information.modify_information}
					</Button>
					<Button onClick={onContinueClick}>{I18n.asset.common.continue}</Button>
				</div>
			</div>
		</Modal>
	);
}
